export default __webpack_public_path__ + "static/media/berlin.e61eeee3.PNG";